const { DataTableEvaluaciones } = require("./datatable");
const { EvaluacionesImages } = require("./fileinput");
const { addFileComponent, removeFileComponent } = require("./addFileComponent");

let evaluacionesTable = null;

const refreshDataTableEvaluaciones = () => {
  evaluacionesTable = evaluacionesTable
    ? evaluacionesTable.ajax.reload(null, false)
    : DataTableEvaluaciones();
};

// Solo ejecutar si los elementos existen en la página
const createEvaluacionEl = document.getElementById("create-evaluacion");
if (createEvaluacionEl) {
  createEvaluacionEl.addEventListener("click", () => {
    EvaluacionesImages();
  });
}

const addFileEl = document.getElementById("addFile");
if (addFileEl) {
  addFileEl.addEventListener("click", () => {
    addFileComponent();
  });
}

// Solo ejecutar si estamos en una página de evaluaciones
if (createEvaluacionEl || addFileEl) {
  removeFileComponent();
  refreshDataTableEvaluaciones();
}
